/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2023, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'
import { SystemStyleFunction } from '@chakra-ui/theme-tools'

const basePillStyle = {
  borderRadius: '30px',
  fontSize: 'md',
  fontWeight: 'medium',
  lineHeight: 'base',
  paddingBottom: 1,
  paddingTop: 0.5,
  paddingX: 3,
  textTransform: 'initial',
}

const variantPillBlue: SystemStyleFunction = () => ({
  ...basePillStyle,
  backgroundColor: 'neutral.150',
  color: 'blue.800',
})

const variantPillGray: SystemStyleFunction = () => ({
  ...basePillStyle,
  backgroundColor: 'gray.150',
  color: 'gray.800',
})

const variantPillYellow: SystemStyleFunction = () => ({
  ...basePillStyle,
  backgroundColor: 'yellow.100',
  color: 'yellow.900',
})

const variants = {
  grayPill: variantPillGray,
  bluePill: variantPillBlue,
  yellowPill: variantPillYellow,
}

export const Z4Badge: ComponentStyleConfig = {
  defaultProps: {},
  variants,
}
